import { AccountType } from '../shared/types'
import { InputSelectOption } from "@sharedComponents/InputSelect/types";

export type AssociationFormProps = {
    myPagesRoute: string
    helpText?: any
    cmsContent?: any
    termsAndConditions?: any
    termsAndConditionsButtons?: Array<any>
    onCancel: Function
    formType?: string | undefined
}

export type Step2ValueModel = {
    organizationNumber: string
    associationName?: string
    registeredForFTax: string
    registeredForVAT: string
    vatNumber?: string
    accountType?: AccountType
    bg?: string
    pg?: string
    careOf?: string
    streetBox?: string
    zipCode?: string
    city?: string
}

export type Step3ValueModel = {
    teamName?: string
    unitName?: string
    municipality?: InputSelectOption
    depositAlternative: string
    visitingAddress: {
        streetAddress?: string
        zipCode?: string
        city?: string
        isAlsoPostalAddress?: boolean
    }
    postalAddress: {
        name?: string
        streetBox?: string
        zipCode?: string
        city?: string
    }
    deliveryAddress?: {
        name?: string
        streetAddress?: string
        zipCode?: string
        city?: string
        acceptDeliveryWithoutSigning?: boolean
    }
    message?: string
    heard?: InputSelectOption
    cardboardContainer?: boolean
    floorballContainer?: boolean
}

export enum DepositAlternatives {
    Pex = 'PEX',
    Bags = 'BAGS',
}